module.exports = __webpack_public_path__ + "img/site-web-refonte-2.8fe4413.jpg";